module.exports = __webpack_public_path__ + "static/img/user.f61c0c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/user.png
// module id = 1Kos
// module chunks = 66